import { ReactElement } from "react";
import { formatDuration } from "client_legacy/ndaw/culture";

export type DurationStringProps = {
	seconds: number;
};

export const DurationString = (props: DurationStringProps): ReactElement => {
	const {
		seconds
	} = props;

	return (
		<>
			{ formatDuration(seconds) }
		</>
	);
};
DurationString.displayName = "DurationString";
